import { jsx as _jsx } from "react/jsx-runtime";
import styles from './GuildPhotoBox.module.scss';
import React from 'react';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
const GuildPhotoBox = ({ guild, className, onClick }) => {
    return (_jsx("div", Object.assign({ className: className, onClick: onClick }, { children: guild.photo ? (_jsx("img", { className: styles.photo, src: guild.photo, alt: '' })) : (_jsx(Logo, { className: styles.photo })) })));
};
export default GuildPhotoBox;
